import { debounce } from "../../@helpers/js/queue-processing.js";

/**
 * Set the 'actual' viewport height based on the current window size.
 */
const viewportHeight = () => {
  document.documentElement.style.setProperty(
    "--viewport-height",
    `${window.innerHeight}px`
  );
};

/**
 * Set height and recall on resize.
 */
export default function initViewportHeight() {
  window.addEventListener("resize", debounce(viewportHeight, 250));
  viewportHeight();
}
